import {
  Typography,
  Box,
  Button,
  useMediaQuery,
  IconButton,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import React, { useState } from "react";
import "./change_password.css";
import { useNavigate } from "react-router-dom";
import TextInput from "../../../components/TextInput/TextInput";
import { useForm } from "react-hook-form";
import getEventController from "../Controller/getEvent_controller";

//icon
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

const ResetPin = () => {
  const navigate = useNavigate(); // Initialize useNavigate hook
  const memberId = localStorage.getItem("memberId"); // Fetch the stored memberId
  const email = localStorage.getItem("email"); // Fetch the stored memberId
  const userId = localStorage.getItem("userId"); // Fetch the stored userId

  const isLargeScreen = useMediaQuery("(min-width:640px)");
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmNewPassword, setShowConfirmNewPassword] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [showNewPin, setShowNewPin] = useState(false);
  const [NewPin, setNewPin] = useState("");
  const [showRetypeNewPin, setShowRetypeNewPin] = useState(false);
  const [RetypeNewPin, setRetypeNewPin] = useState("");

  const [error, setError] = useState(null);

  const toggleOldPasswordVisibility = () => {
    setShowOldPassword((prev) => !prev);
  };

  const toggleNewPinVisibility = () => {
    setShowNewPin((prev) => !prev);
  };
  const toggleRetypeNewPinVisibility = () => {
    setShowRetypeNewPin((prev) => !prev);
  };

  const handleResetPin = async (e) => {
    e.preventDefault();
    setError(null);

    console.log(oldPassword);
    console.log(NewPin);
    console.log(RetypeNewPin);

    if (NewPin !== RetypeNewPin) {
      setError("New Pin and Retype Pin do not match.");
      return;
    }

    const response = await getEventController.ResetPin(
      userId,
      oldPassword,
      NewPin
    );

    if (response.success) {
      alert("Pin reset successfully!");
      navigate("/profile"); // Redirect or provide feedback
    } else {
      alert(response.message || "Failed to reset pin. Please try again.");
    }
  };

  const {
    handleSubmit,
    register,
    formState: { errors },
    control,
    reset,
  } = useForm({
    defaultValues: {
      eventName: "",
      description: "",
      venue: "",
      poster: "",
      earlyBirdStartDate: "",
      earlyBirdEndDate: "",
      registrationStartDate: "",
      registrationEndDate: "",
      eventStartDateTime: "",
      eventEndDateTime: "",
      earlyBirdPrice: "",
      registrationPrice: "",
      numberOfPax: "",
      eventCategory: "",
    },
  });

  return (
    <React.Fragment>
      {!isLargeScreen ? (
        <div className="edit-password">
          <Box sx={{ display: "flex" }}>
            <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
              {/* <DrawerHeader /> */}
              {/* {showAlertSuccess && (
              <Alert severity="success" sx={{ mb: 2 }}>
                {alertSuccessMsg}
              </Alert>
            )} */}

              <form>
                <Box sx={{ flexGrow: 1 }}>
                  <Grid container spacing={2}>
                    <Grid size={{ xs: 12, md: 12 }}>
                      <label>Old Password</label>
                      <TextInput
                        type="text"
                        {...register("eventName", {
                          required: "This field is required",
                        })}
                        onErrorCheck={
                          errors.eventName ? errors.eventName.message : ""
                        }
                        control={control}
                      />
                    </Grid>
                    <Grid size={{ xs: 12, md: 12 }}>
                      <label>New Password</label>
                      <TextInput
                        type="text"
                        {...register("eventName", {
                          required: "This field is required",
                        })}
                        onErrorCheck={
                          errors.eventName ? errors.eventName.message : ""
                        }
                        control={control}
                      />
                    </Grid>
                    <Grid size={{ xs: 12, md: 12 }}>
                      <label>Retype New Password</label>
                      <TextInput
                        type="text"
                        {...register("eventName", {
                          required: "This field is required",
                        })}
                        onErrorCheck={
                          errors.eventName ? errors.eventName.message : ""
                        }
                        control={control}
                      />
                    </Grid>
                  </Grid>

                  <Box textAlign="center">
                    <Button
                      sx={{
                        borderRadius: "20px",
                        mt: 4,
                        mb: 4,
                        width: "100%",
                        height: "48px",
                        backgroundColor: "#d33333",
                        textTransform: "none",
                      }}
                      variant="contained"
                      type="submit"
                    >
                      <Typography variant="h6">Update Password</Typography>
                    </Button>
                  </Box>
                </Box>
              </form>
            </Box>
          </Box>
        </div>
      ) : (
        <div className="reset-pin">
          <div>
            <ArrowBackIosIcon
              className="logo"
              onClick={() => navigate(-1)}
              label="BACK"
            />
            {/* <span>BACK </span> */}
          </div>
          <div className="change-password-title">
            <span>Reset Pin</span>
          </div>
          <Box sx={{ display: "flex" }}>
            <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
              {/* <DrawerHeader /> */}
              {/* {showAlertSuccess && (
            <Alert severity="success" sx={{ mb: 2 }}>
              {alertSuccessMsg}
            </Alert>
          )} */}

              <form onSubmit={handleResetPin}>
                <Box sx={{ flexGrow: 1 }}>
                  <Grid container spacing={2}>
                    {/* Old Password */}
                    <Grid size={{ xs: 12, md: 12 }}>
                      <label>Account Password</label>
                      <div className="cp-input-row">
                        <input
                          name="old_password"
                          className="cp-input col-md-11"
                          type={showOldPassword ? "text" : "password"}
                          placeholder="Your Account Password"
                          required
                          value={oldPassword}
                          onChange={(e) => setOldPassword(e.target.value)}
                        />
                        <IconButton
                          className="col-md-1"
                          onClick={toggleOldPasswordVisibility}
                          sx={{
                            padding: 0,
                          }}
                        >
                          {showOldPassword ? (
                            <VisibilityIcon />
                          ) : (
                            <VisibilityOffIcon />
                          )}
                        </IconButton>
                      </div>
                    </Grid>
                    {/* New 6-digits pin */}
                    <Grid size={{ xs: 12, md: 12 }}>
                      <label>New 6-digits pin</label>
                      <div className="cp-input-row">
                        <input
                          className="cp-input col-md-11"
                          type={showNewPin ? "text" : "password"}
                          placeholder="New Pin"
                          required
                          value={NewPin}
                          onChange={(e) => {
                            // Restrict input to numbers and limit length to 6
                            const numericValue = e.target.value.replace(
                              /\D/g,
                              ""
                            ); // Remove non-digit characters
                            if (numericValue.length <= 6) {
                              setNewPin(numericValue);
                            }
                          }}
                        />
                        <IconButton
                          className="col-md-1"
                          onClick={toggleNewPinVisibility}
                          sx={{
                            padding: 0,
                          }}
                        >
                          {showNewPin ? (
                            <VisibilityIcon />
                          ) : (
                            <VisibilityOffIcon />
                          )}
                        </IconButton>
                      </div>
                    </Grid>
                    {/* Confirm New Pin */}
                    <Grid size={{ xs: 12, md: 12 }}>
                      <label>Retype New Pin</label>
                      <div className="cp-input-row">
                        <input
                          className="cp-input col-md-11"
                          type={showRetypeNewPin ? "text" : "password"}
                          placeholder="Retype Pin"
                          required
                          value={RetypeNewPin}
                          onChange={(e) => {
                            // Restrict input to numbers and limit length to 6
                            const numericValue = e.target.value.replace(
                              /\D/g,
                              ""
                            ); // Remove non-digit characters
                            if (numericValue.length <= 6) {
                              setRetypeNewPin(numericValue);
                            }
                          }}
                        />
                        <IconButton
                          className="col-md-1"
                          onClick={toggleRetypeNewPinVisibility}
                          sx={{
                            padding: 0,
                          }}
                        >
                          {showRetypeNewPin ? (
                            <VisibilityIcon />
                          ) : (
                            <VisibilityOffIcon />
                          )}
                        </IconButton>{" "}
                      </div>
                    </Grid>
                  </Grid>

                  {error && <p className="error-message">{error}</p>}

                  <Box>
                    <Button
                      sx={{
                        borderRadius: "20px",
                        mt: 4,
                        mb: 4,
                        maxWidth: "800px",
                        width: "100%",
                        height: "48px",
                        backgroundColor: "#d33333",
                        textTransform: "none",
                      }}
                      variant="contained"
                      type="submit"
                    >
                      <Typography variant="h6">Save Pin</Typography>
                    </Button>
                  </Box>
                </Box>
              </form>
            </Box>
          </Box>
        </div>
      )}
    </React.Fragment>
  );
};

export default ResetPin;
